module.exports = __webpack_public_path__ + "img/pb2.007b51c2.jpg";